import React from "react";
import PropTypes from "prop-types";
import { logError } from "../utils/errorLogger";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        logError('ErrorBoundary', { error, errorInfo });
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className='flex items-center justify-center auth_main'>
                    <div className="text-center">
                        <p className="font-bold" style={{ fontSize: '1.2rem', color: '#1E1E1E' }}>Something went wrong.</p>
                        <p style={{ color: '#1E1E1E' }}>Please refresh the page and try again.</p>
                        <button className='gradient_button mt-3' onClick={() => window.location.reload()}>
                            Refresh
                        </button>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

ErrorBoundary.propTypes = {
    children: PropTypes.node,
};

export default ErrorBoundary;
